/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Real_Fair_Haddock_TwirlInputs */

const fr_real_fair_haddock_twirl = /** @type {(inputs: Real_Fair_Haddock_TwirlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme`)
};

/**

* @param {Real_Fair_Haddock_TwirlInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const real_fair_haddock_twirl = /** @type {((inputs?: Real_Fair_Haddock_TwirlInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Real_Fair_Haddock_TwirlInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_real_fair_haddock_twirl(inputs)
});